import { registerExtension } from "@core/components/PipelineComponents/ExtensionProvider";
import { Link } from "@remix-run/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIdBadge } from "@fortawesome/pro-light-svg-icons";
import { t } from "i18next";

const ProviderPassQuickLink = () => {
  return (
    <Link
      to="/dashboard/settings/profile?tab=personal"
      className="flex items-center gap-3 p-3 rounded-md border border-border hover:bg-muted/60"
    >
      <FontAwesomeIcon icon={faIdBadge} className="text-muted-foreground" />
      <span className="text-sm">
        {t("providerpass.quicklink", "Verify EPCS Identity")}
      </span>
    </Link>
  );
};

registerExtension(
  "_site.dashboard._index.quickLinks",
  ProviderPassQuickLink,
  "ProviderPassQuickLink"
);
